import { connect } from "react-redux";

import ConverterManagerPool from "../Components/Converters/ConverterManagerPool";
import {
  addConverter,
  removeConverter,
  updateConverterType,
  updateConverterOrder,
  updateConverterId,
  setConfigParam,
  copyConverter,
  getConverterConfig,
  setConvertersManagerOpen,
  setConverterConfigOpen,
  setConverterOnEdition,
} from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    converters: state.converters,
    locale: state.locale,
    isConvertersManagerOpen: state.isConvertersManagerOpen,
    isConverterConfigOpen: state.isConverterConfigOpen,
    converterOnEdition: state.converterOnEdition,
  };
};

const mapDispatchToProps = {
  addConverter,
  removeConverter,
  updateConverterType,
  updateConverterOrder,
  updateConverterId,
  setConfigParam,
  copyConverter,
  getConverterConfig,
  setConvertersManagerOpen,
  setConverterConfigOpen,
  setConverterOnEdition,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConverterManagerPool);
